import React from 'react';
import { dollarFormat } from 'utils/utils';

export default function Total({ due_amount, running_trust_balance }) {
  const footerDueAmount = () => dollarFormat(due_amount) ?? '0.0';
  const footerBalance = () => dollarFormat(running_trust_balance) ?? '0.0';
  return (
    <div className="inner-card p-3 mb-3">
      <div className="gap-5 flex-wrap d-flex">
        <div className="total-cases">
          <p className="F-size12 mb-0 black-600 mb-0">Total Balance</p>
          <p className="text-bold F-size14">{footerBalance()}</p>
        </div>
        <div className="average-case-age">
          <p className="F-size12 mb-0 black-600 mb-0">Total Past Due to Trust</p>
          <p className="text-bold F-size14">{footerDueAmount()}</p>
        </div>
      </div>
    </div>
  );
}
